/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ReplaceIdentityProviderConnectionClientSecretRequestBody = {
  /**
   * New client secret from the Speakeasy integration in Okta. Encrypted before persisting and never returned.
   */
  clientSecret: string;
  /**
   * Connection ID.
   */
  id: string;
};

/** @internal */
export type ReplaceIdentityProviderConnectionClientSecretRequestBody$Outbound =
  {
    client_secret: string;
    id: string;
  };

/** @internal */
export const ReplaceIdentityProviderConnectionClientSecretRequestBody$outboundSchema:
  z.ZodMiniType<
    ReplaceIdentityProviderConnectionClientSecretRequestBody$Outbound,
    ReplaceIdentityProviderConnectionClientSecretRequestBody
  > = z.pipe(
    z.object({
      clientSecret: z.string(),
      id: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        clientSecret: "client_secret",
      });
    }),
  );

export function replaceIdentityProviderConnectionClientSecretRequestBodyToJSON(
  replaceIdentityProviderConnectionClientSecretRequestBody:
    ReplaceIdentityProviderConnectionClientSecretRequestBody,
): string {
  return JSON.stringify(
    ReplaceIdentityProviderConnectionClientSecretRequestBody$outboundSchema
      .parse(replaceIdentityProviderConnectionClientSecretRequestBody),
  );
}
